import React from 'react';
import {
  Menu,
  Segment,
  Sidebar
} from 'semantic-ui-react';
import classNames from 'classnames';

// const ContentBreadcrumb = () => (
//   <Breadcrumb>
//     <Breadcrumb.Section as={Link} to="/">Homepage</Breadcrumb.Section>
//     <Breadcrumb.Divider icon='right angle' />
//     <Breadcrumb.Section active>Dashboard</Breadcrumb.Section>
//   </Breadcrumb>
// )

class Content extends React.Component {
  render = () => {
    const {
      children,
      loading,
      fullWidth,
      isSideBarHidden
    } = this.props;
    return (
      <Sidebar.Pushable as={'div'} className='o-fill'>
        {this.renderSideBar()}
        <Sidebar.Pusher className={classNames({
            'o-fill': true,
            'c-Content__content': true,
            'c-Content__content--margined': !fullWidth && !isSideBarHidden
        })}>
          <Segment basic loading={loading} className="o-fill">

              {children}

          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    )
  }

  renderSideBar() {
    const {
      MenuItems,
      menuProps = {},
      onApply,
      isSideBarHidden
    } = this.props;
    if(!isSideBarHidden)
      return (
        <Sidebar animation='overlay' direction='right' as={Menu} vertical visible={!!MenuItems}>
          {MenuItems && <MenuItems {...menuProps} onApply={onApply}/>}
        </Sidebar>
      )
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/component/Content.js